module.exports = __webpack_public_path__ + "static/media/tmmnzlBackground.e90866e6.png";